<template>
    <div class="page-home">
        <div class="top-content-wrap" v-if="recommendGoods.length > 0">
            <div class="common-title">推荐商品</div>
            <el-card v-for="item in recommendGoods" class="recommend-goods-card">
                <div class="recommend-goods-name">{{ item.human_name }}</div>
                <div class="recommend-goods-suptitle">{{ item.human_desc }}</div>
                <el-image :src="item.human_img" :fit="fit" class="recommend-goods-img"></el-image>
                <el-button class="recommend-goods-btn" @click="handleClick(item)">购买</el-button>
                <div class="recommend-goods-price">0元/1天</div>
                <div class="recommend-goods-price">{{ item.created_at }}，发布</div>
            </el-card>
        </div>
        <div class="top-content-wrap">
            <div class="common-title">数字人形象</div>
            <el-card v-for="item in goodsList" class="recommend-goods-card">
                <div class="recommend-goods-name">{{ item.human_name }}</div>
                <div class="recommend-goods-suptitle">{{ item.human_desc }}</div>
                <el-image :src="item.human_img" :fit="fit" class="recommend-goods-img"></el-image>
                <el-button class="recommend-goods-btn" @click="handleClick(item)">购买</el-button>
                <div class="recommend-goods-price">0元/1天</div>
                <div class="recommend-goods-price">{{ item.created_at }}，发布</div>
            </el-card>
        </div>
        <el-dialog v-model="dialogVisible" title="订单确认" width="30%">
            <div class="confirm-order-wrap">
                <el-image :src="confirmOrder.humanImg" :fit="fit" class="confirm-order-img"></el-image>
                <div class="confirm-order-name">{{ confirmOrder.name }}</div>
                <div class="confirm-order-desc">免费试用,无需购买</div>
                <div class="confirm-order-desc">唤醒词：{{ confirmOrder.call_txt }}</div>
                <el-button class="confirm-order-btn" v-if="buying">形象传输中,请稍后...</el-button>
                <el-button class="confirm-order-btn" v-else @click="buyGoods">购买并使用</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { reactive, toRefs, onMounted } from 'vue';
import { useRouter } from 'vue-router'
import { recommendList, humanList, deviceList, bindHuman } from '@/api/index'
import { ElMessage } from 'element-plus'
export default {
    name: 'home',
    setup() {
        const state = reactive({
            fit:'contain',
            dialogVisible: false,
            buying: false,
            confirmOrder: {
                humanId: '',
                humanName: '',
                humanImg: '',
                call_txt:''
            },
            recommendGoods: [],
            goodsList: []
        })
        onMounted(() => {
            fetchRecommendList()
            fetchHumanList()
        })
        const fetchRecommendList = async () => {
            const res = await recommendList()
            if (res.code == 200) {
                state.recommendGoods = res.data
            } else {
                ElMessage.error('数据获取失败')
                state.recommendGoods = []
            }
        }
        const fetchHumanList = async () => {
            const res = await humanList()
            if (res.code == 200) {
                state.goodsList = res.data
            } else {
                ElMessage.error('数据获取失败')
                state.goodsList = []
            }
        }
        const handleClick = (item) => {
            state.confirmOrder.humanId = item.id
            state.confirmOrder.humanName = item.human_name
            state.confirmOrder.humanImg = item.human_img
            state.confirmOrder.call_txt = item.call_txt
            state.dialogVisible = true
        }
        const fetchDeviceList = async () => {
            const params = {
                page: 1,
                limit: 1000
            }
            const res = await deviceList(params)
            if (res.code == 200) {
                const deviceIds = res.data.map(item => item.id)
                return deviceIds
            } else {
                ElMessage.error('获取设备列表失败')
                return []
            }
        }
        const buyGoods = async () => {
            state.buying = true
            const deviceIds = await fetchDeviceList()
            const data = {
                device_ids: deviceIds,
                human_id: state.confirmOrder.humanId
            }
            if (deviceIds.length > 0) {
                const res = await bindHuman(data)
                if (res.code == 200) {
                    state.dialogVisible = false
                    state.buying = false
                    ElMessage.success('数字人形象购买或使用成功')
                } else {
                    state.dialogVisible = false
                    state.buying = false
                    ElMessage.error('数字人形象购买或使用失败')
                }
            }else{
                ElMessage.error('未找到可以使用的设备,请先绑定设备')
            }

        }
        return {
            ...toRefs(state),
            handleClick,
            buyGoods
        }
    }
}
</script>
<style lang="less" scoped>
.page-home {
    .common-title {
        font-size: 20px;
        font-weight: 600;
        color: #333;
    }

    .top-content-wrap {
        margin-left: 20px;
        margin-top: 20px;
        margin-bottom: 10px;

        .recommend-goods-card {
            width: 244px;
            display: inline-block;
            text-align: center;
            margin-top: 20px;
            margin-left: 20px;
            color: #333;

            .recommend-goods-name {
                font-size: 18px;
            }

            .recommend-goods-suptitle {
                font-size: 14px;
                margin-top: 10px;
            }

            .recommend-goods-img {
                width: 200px;
                height: 180px;
                margin: 0 auto;
                margin-top: 10px;
            }

            .recommend-goods-btn {
                width: 160px;
                margin-top: 10px;
            }

            .recommend-goods-price {
                margin-top: 10px;
                font-size: 14px;
            }
        }
    }

    .confirm-order-wrap {
        text-align: center;

        .confirm-order-img {
            width: 200px;
            height: 180px;
            margin: 0 auto;
        }

        .confirm-order-name {
            margin-top: 10px;
            font-size: 18px;
        }

        .confirm-order-desc {
            margin-top: 10px;
            font-size: 14px;
        }

        .confirm-order-btn {
            width: 160px;
            margin-top: 20px;
            margin-bottom: 20px;
        }
    }
}
</style>